import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const TrainingGuard = ({ children }) => {
  const hasPendingTraining = useSelector(
    (state) => state.user.hasPendingTraining
  );
  const location = useLocation();

  // Allow training route
  if (hasPendingTraining && location.pathname !== "/training") {
    return <Navigate to="/training" replace />;
  }

  return children;
};

export default TrainingGuard;